import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="home">

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-inner">
          <div className="hero-heading">
            <span className="hero-eyebrow">Social intelligence for creators</span>
            <h1>Smarter Social Starts Here</h1>
          </div>

          <div className="hero-grid">
            <div className="hero-summary">
              <p>
                ChicLogic.io is your effortless edge in the content game — combining AI insights with data-backed social media research, 
                optimized captions, and clear strategy tools. Whether you’re building your first post or scaling your brand, 
                we help you grow without the guesswork.
              </p>
              <div className="hero-cta-row">
                <Link to="/signup" className="cta-button hero-cta-primary">Start free trial</Link>
                <Link to="/hashtag-research" className="hero-cta-secondary">Preview hashtag library</Link>
              </div>
            </div>

            <div className="hero-visual" aria-label="Hashtag performance preview">
              <div className="hero-card hero-card--primary">
                <div className="hero-card-header">
                  <h4>Trending hashtag plan</h4>
                  <span className="hero-card-pill">Updated hourly</span>
                </div>
                <ul>
                  <li>
                    <span className="hero-tag">#mindfulmonday</span>
                    <span className="hero-metric">84k est. reach</span>
                  </li>
                  <li>
                    <span className="hero-tag">#creatorstudio</span>
                    <span className="hero-metric">61k est. reach</span>
                  </li>
                  <li>
                    <span className="hero-tag">#stayconsistent</span>
                    <span className="hero-metric">52k est. reach</span>
                  </li>
                </ul>
              </div>
              <div className="hero-card hero-card--kpi">
                <span className="hero-kpi">+35%</span>
                <p>Average reach lift when creators publish with ChicLogic.io intelligence.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section id="features" className="section">
        <h3>What You Get</h3>
        <ul className="features">
          <li>✔️ AI-generated hashtag recommendations</li>
          <li>✔️ Realtime Instagram view count insights</li>
          <li>✔️ Save hashtag bundles for quick reuse</li>
          <li>✔️ Support for multiple accounts</li>
          <li>✔️ Sleek dashboard and smart tools</li>
        </ul>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <h3>Join creators already leveling up</h3>
        <p>Start using ChicLogic.io free and discover the power of AI for your brand.</p>
        <Link to="/signup" className="cta-button cta-button--light">Create Free Account</Link>
      </section>

      {/* Footer */}
      <footer className="footer">
        © 2025 ChicLogic.io. All rights reserved.
      </footer>
    </div>
  );
};

export default HomePage;
